// A person's private details live apart from their public profile (2026-11-01). The users collection has to stay
// readable by anyone (sign-in, guide owner names and the share list look people up there), and it held every
// email address, the travel documents (travelers) and payment info. Those now live in user_private/<uid>, which
// only that person (and the app admin) can read; "share by email" finds a person through user_emails/<address>,
// which answers one exact address and can't be listed. The app keeps one user_info object: these helpers split it
// for saving and merge it back after reading. Mobile has the same file (andiamo-places src/Common/userPrivacy.js).

export const PRIVATE_FIELDS = ["email", "travelers", "payment_info"];

// "  Tom@Example.com " → "tom@example.com" (sign-in stores addresses lowercase; the index is keyed the same way)
export const emailKey = (email) => String(email || "").trim().toLowerCase();

// { pub, priv }: priv has only the private fields the user object actually carries
export function splitUser(user) {
  const pub = { ...(user || {}) };
  const priv = {};
  PRIVATE_FIELDS.forEach((k) => {
    if (k in pub) {
      if (pub[k] !== undefined) priv[k] = pub[k];
      delete pub[k];
    }
  });
  return { pub, priv };
}

// The public profile with the private record on top. Before the move (no private record yet) the profile still
// carries the private fields itself, and those are used as they are.
export function mergeUser(pub, priv) {
  return priv ? { ...(pub || {}), ...priv } : { ...(pub || {}) };
}

// What a legacy profile (written before 2026-11-01) still carries that belongs in the private record, or null.
export function legacyPrivate(pub) {
  const { priv } = splitUser(pub);
  return Object.keys(priv).length ? priv : null;
}
